import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { VariationOfAddon } from "../../../../Constant";
import { VARIATION_OF_ADDONS } from "../../../../Data/FormControl/InputGroups";
import VariationAddonsFormContent from "./VariationAddonsFormContent";
import { VariationOfAddonsCardFooter } from "./VariationOfAddonsCardFooter";

const VariationOfAddons = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={VariationOfAddon} span={VARIATION_OF_ADDONS} />
        <CardBody className="card-wrapper input-radius">
          <Row>
            <Col>
              <VariationAddonsFormContent />
            </Col>
          </Row>
        </CardBody>
        <VariationOfAddonsCardFooter />
      </Card>
    </Col>
  );
};

export default VariationOfAddons;
